// WaterDensityCalculator.js
import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Menghitung Massa Jenis Air - Kalkulator Massa Jenis Air";
const DESCRIPTION =
  "Gunakan kalkulator massa jenis air untuk menghitung massa jenis air atau zat lain dengan mudah menggunakan persamaan: massa jenis = massa zat / volume zat. Pelajari cara mengonversi satuan massa jenis dan memahami konsep massa jenis.";
const KEYWORDS =
  "kalkulator massa jenis air, massa jenis bahan, menghitung massa jenis, massa zat, volume zat, gram/cm3, kg/m3, fisika, hukum massa jenis";
const OG_URL =
  "https://do-calculate.com/calculator/id/water-density-calculator/";
function WaterDensityCalculator() {
  const [mass, setMass] = useState(0);
  const [volume, setVolume] = useState(0);
  const [result, setResult] = useState();
  const [error, setError] = useState("");
  const handleCalculate = () => {
    try {
      if (mass && volume) {
        const density = parseFloat(mass) / parseFloat(volume);
        setResult(density);
      }
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Kalkulator ini menghitung massa jenis air atau zat lain menggunakan persamaan berikut:
                </p>
                <p>
                  <strong>Massa Jenis = Massa Zat / Volume Zat</strong>
                </p>
                <ul>
                  <li>
                    Masukkan massa zat dan volumenya untuk menghitung massa jenis dalam satuan gram/cm³ atau
                    kg/m³.
                  </li>
                  <li>
                    Massa jenis air pada suhu 4 derajat Celcius sama dengan 1 gram/cm³ atau
                    1000 kg/m³.
                  </li>
                </ul>
                <p>
                  Kalkulator ini dikembangkan untuk memudahkan proses menghitung massa jenis dan memahami hubungan
                  antara massa dan volume untuk zat apa pun.
                </p>
                <hr />
              </div>
              <br />
            </div>
               <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div >
                  <div>
                    <hr />
                    <div className="form-group" htmlFor="mass">
                      <label className="form-label ms-2">
                        Masukkan Massa Zat (gram)
                      </label>
                      <input
                        id="mass"
                        type="number"
                        value={mass}
                        onChange={(e) => setMass(e.target.value)}
                        placeholder="Masukkan massa zat"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group" htmlFor="volume">
                      <label className="form-label ms-2">
                        Masukkan Volume Zat (cm³)
                      </label>
                      <input
                        id="volume"
                        type="number"
                        value={volume}
                        onChange={(e) => setVolume(e.target.value)}
                        placeholder="Masukkan volume zat"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      Hitung
                    </button>
                  </div>
                  <br />
                  { error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      Kesalahan: {error}
                    </p>
                  )}
                  {result &&  (
                    <div className="p-3 mb-2 bg-success">
                      <h4 className="text-white">Hasil:</h4>
                      <p className="text-white">{result} gram/cm³</p>
                      <div
                        className="p-3 mb-2 bg-info text-black"
                        style={{ width: "100%" }}
                      >
                        <h4 style={{ color: "black" }}>Langkah-langkah Penyelesaian:</h4>
                        <ol>
                          <li>
                            Menghitung massa jenis menggunakan persamaan: Massa Jenis = Massa / Volume
                          </li>
                          <li>
                            Massa Jenis = {mass} gram / {volume} cm³ = {result}{" "}
                            gram/cm³
                          </li>
                        </ol>
                      </div>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">Apa itu Massa Jenis?</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>Konsep Massa Jenis</h2>
                  </u>
                  <p>
                    Massa jenis adalah jumlah massa per satuan volume suatu zat, dan dihitung dengan
                    rumus berikut:
                  </p>
                  <ul>
                    <li>
                      <strong>Massa Jenis = Massa / Volume</strong>
                    </li>
                    <li>Massa jenis dinyatakan dalam satuan seperti gram/cm³ atau kg/m³.</li>
                  </ul>
                  <div className="p-3 mb-2 bg-info text-black">
                    Contoh: Massa jenis air sama dengan 1 gram/cm³ pada suhu 4 derajat Celcius.
                  </div>
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>Bagaimana Menghitung Massa Jenis Bahan?</h2>
                  </u>
                  <p>Massa jenis zat apa pun dapat dihitung menggunakan persamaan:</p>
                  <ul>
                    <li>
                      Masukkan massa zat dan volumenya ke dalam kalkulator untuk mendapatkan massa jenis.
                    </li>
                    <li>Pastikan untuk menggunakan satuan yang konsisten saat memasukkan nilai.</li>
                  </ul>
                  <div className="p-3 mb-2 bg-info text-black">
                    Contoh: Jika massa suatu zat 500 gram dan volumenya 250 cm³, maka
                    massa jenisnya sama dengan 2 gram/cm³.
                  </div>
                </div>
                <hr />
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default WaterDensityCalculator;